import script from "./getTree.vue?vue&type=script&setup=true&lang=js"
export * from "./getTree.vue?vue&type=script&setup=true&lang=js"

import "./getTree.vue?vue&type=style&index=0&id=6d7a4208&lang=css"

const __exports__ = script;

export default __exports__